import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { ConversationProfile } from '@app/modules/messaging/models/conversation-profile.model'

import type { UnsentVoiceMessage } from '../models/voice-message.model'

export const voiceSendingEvents = eventGroup({
  source: 'Voice Sending',
  events: {
    removeVoice: type<void>(),
    restoreCache: type<{ voice: UnsentVoiceMessage | undefined }>(),
    removeCache: type<{ profile: ConversationProfile }>(),
    exitVoice: type<void>(),
  },
})
